import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';

// Layout Components
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';

// Pages
import Home from '@/pages/Home';
import About from '@/pages/About';
import Services from '@/pages/Services';
import Resources from '@/pages/Partners';
import Contact from '@/pages/Contact';
import Impressum from '@/pages/Impressum';
import Admin from '@/pages/Admin';
import Press from '@/pages/Press';
import PressArticle from '@/pages/PressArticle';
import Datenschutz from '@/pages/Datenschutz';
import CookieBanner from '@/components/CookieBanner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ueber-mich" element={<About />} />
            <Route path="/leistungen" element={<Services />} />
            <Route path="/partner" element={<Resources />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/presse" element={<Press />} />
            <Route path="/presse/:id" element={<PressArticle />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
          </Routes>
        </main>
        <Footer />
        <CookieBanner />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
